'use strict';

var _ = require('lodash');
var UserManagementSelectedRoleService = function UserManagementSelectedRoleService() {
  var selectedRoleAssigned;
  function selectedRole(role) {
    selectedRoleAssigned = role;
  }
  function getSelectedRole() {
    return selectedRoleAssigned;
  }
  function refreshUsersAssigned() {
    return _.get(selectedRoleAssigned, 'usersAssigned', 0);
  }
  return {
    selectedRole: selectedRole,
    getSelectedRole: getSelectedRole,
    refreshUsersAssigned: refreshUsersAssigned
  };
};
UserManagementSelectedRoleService.$inject = [];
module.exports = UserManagementSelectedRoleService;